var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "900", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "d-flex justify-center" }, [
            _c("span", { staticClass: "text-h5 font-weight-bold" }, [
              _vm._v(
                " Establecimientos - [" +
                  _vm._s(_vm.config.IdCompania) +
                  "] " +
                  _vm._s(_vm.config.NombreCompania) +
                  " "
              ),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12", sm: "2" } }),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "5" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          label: "Establecimiento asignado a la campaña",
                          outlined: "",
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.saveStore.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.codeStore,
                          callback: function ($$v) {
                            _vm.codeStore = $$v
                          },
                          expression: "codeStore",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: {
                            "background-color": "rgb(204 33 40)",
                            color: "white !important",
                          },
                          on: { click: _vm.saveStore },
                        },
                        [_vm._v(" AGREGAR ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-alert",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errorAlert,
                      expression: "errorAlert",
                    },
                  ],
                  staticClass: "mt-3",
                  attrs: { type: "warning", text: "" },
                },
                [_vm._v(" " + _vm._s(_vm.msgErrorAlert) + " ")]
              ),
              _c("v-data-table", {
                staticClass: "mt-4",
                attrs: { headers: _vm.headers, items: _vm.stores },
                scopedSlots: _vm._u([
                  {
                    key: "item.CodeStore",
                    fn: function ({ item }) {
                      return [
                        _c("div", { staticClass: "text-center" }, [
                          _vm._v(" " + _vm._s(item.CodeStore) + " "),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.TokenKey",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.copyToken(
                                                        item.TokenKey
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("v-icon", [
                                                _vm._v(" mdi-content-copy "),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v(" Copiar Token ")])]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.Active",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-center" },
                          [
                            _c("v-switch", {
                              attrs: { inset: "" },
                              on: {
                                change: function ($event) {
                                  return _vm.changeStatus(item)
                                },
                              },
                              model: {
                                value: item.Active,
                                callback: function ($$v) {
                                  _vm.$set(item, "Active", $$v)
                                },
                                expression: "item.Active",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c("v-btn", { attrs: { text: "" }, on: { click: _vm.close } }, [
                _vm._v(" CERRAR "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }